import { createContext, useCallback, useContext, useState } from "react";

const VerificationDialogContext = createContext(null);

export function VerificationDialogProvider({ children }) {
  const [open, setOpen] = useState(false);

  const openDialog = useCallback(() => setOpen(true), []);
  const closeDialog = useCallback(() => setOpen(false), []);

  return (
    <VerificationDialogContext.Provider value={{ open, openDialog, closeDialog, setOpen }}>
      {children}
    </VerificationDialogContext.Provider>
  );
}

export function useVerificationDialog() {
  const ctx = useContext(VerificationDialogContext);
  if (!ctx)
    throw new Error(
      "useVerificationDialog must be used within VerificationDialogProvider"
    );
  return ctx;
}
